import React from 'react';
import { Link } from 'react-router-dom';

function Hero() {
  return (
    <>
      {/* Hero Carousel Section - Full Width */}
      <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000" data-bs-pause="false" style={{ 
        overflow: 'hidden',
        position: 'relative',
        minHeight: '65vh'
      }}>
        {/* Animated Pattern Overlay */}
        <div style={{
          content: '',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
          backgroundSize: '80px 80px',
          backgroundRepeat: 'repeat',
          animation: 'float 20s ease-in-out infinite',
          zIndex: 1,
          pointerEvents: 'none'
        }}></div>
        
        {/* Gradient Border Bottom */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '5px',
          background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
          backgroundSize: '200% 100%',
          animation: 'shimmer 3s ease-in-out infinite',
          zIndex: 3
        }}></div>
        
        <div className="carousel-indicators" style={{ marginBottom: '20px', zIndex: 4 }}>
          <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1" style={{ 
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundColor: '#7B3F9E'
          }}></button>
          <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2" style={{ 
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundColor: '#7B3F9E'
          }}></button>
        </div>
        
        <div className="carousel-inner" style={{ position: 'relative', zIndex: 2 }}>
          <div className="carousel-item active" data-bs-interval="5000">
            <div style={{ position: 'relative', minHeight: '65vh', display: 'flex', alignItems: 'center' }}>
              <img src="/assets/img/dtk2.jpg" className="d-block w-100" alt="DTK College" style={{ 
                height: '65vh', 
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              }} />
              {/* Dark Overlay */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%)'
              }}></div>
              
              {/* Centered Content */}
              <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
                <div className="row justify-content-center text-center">
                  <div className="col-lg-8" style={{ width: '86.66666667%', maxWidth: '86.66666667%' }}>
                    {/* Animated Badge */}
                    <div style={{
                      display: 'inline-block',
                      backgroundColor: 'rgba(123, 63, 158, 0.2)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 30px',
                      borderRadius: '50px',
                      marginBottom: '30px',
                      border: '2px solid rgba(123, 63, 158, 0.4)',
                      boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                    }}>
                      <span style={{ 
                        color: '#e0d9e4ff', 
                        fontSize: '1.7rem', 
                        fontWeight: '800', 
                        letterSpacing: '2px',
                        textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                      }}>
                        🎓 DTK COLLEGE OF TECHNOLOGY AND MANAGEMENT STUDIES
                      </span>
                    </div>
                    
                    {/* Decorative Line */}
                    <div style={{
                      width: '150px',
                      height: '6px',
                      background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                      margin: '0 auto 35px',
                      borderRadius: '10px',
                      boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                    }}></div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item" data-bs-interval="5000">
            <div style={{ position: 'relative', minHeight: '65vh', display: 'flex', alignItems: 'center' }}>
              <img src="/assets/img/dkt3.jpg" className="d-block w-100" alt="DTK College" style={{ 
                height: '65vh', 
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              }} />
              {/* Dark Overlay */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%)'
              }}></div>
              
              {/* Centered Content */}
              <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
                <div className="row justify-content-center text-center">
                  <div className="col-lg-8" style={{ width: '86.66666667%', maxWidth: '86.66666667%' }}>
                    {/* Animated Badge */}
                    <div style={{
                      display: 'inline-block',
                      backgroundColor: 'rgba(123, 63, 158, 0.2)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 30px',
                      borderRadius: '50px',
                      marginBottom: '30px',
                      border: '2px solid rgba(123, 63, 158, 0.4)',
                      boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                    }}>
                      <span style={{ 
                        color: '#e0d9e4ff', 
                        fontSize: '1.7rem', 
                        fontWeight: '800', 
                        letterSpacing: '2px',
                        textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                      }}>
                        🎓 DTK COLLEGE OF TECHNOLOGY AND MANAGEMENT STUDIES
                      </span>
                    </div>
                    
                    {/* Decorative Line */}
                    <div style={{
                      width: '150px',
                      height: '6px',
                      background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                      margin: '0 auto 35px',
                      borderRadius: '10px',
                      boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                    }}></div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev" style={{ zIndex: 4 }}>
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next" style={{ zIndex: 4 }}>
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>

        {/* Add CSS animations */}
        <style>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          @keyframes shimmer {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}</style>
      </div>

      {/* Content Section */}
      <section id="hero" className="hero section" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #FDFCFE 100%)', minHeight: '100vh', paddingTop: '80px' }}>
        <div className="container" data-aos="fade-up">
          {/* Summer Term Box */}
        <div className="row justify-content-center mb-5" data-aos="fade-up" data-aos-delay="300">
          <div className="col-lg-8">
            <div className="shadow-lg" style={{ 
              backgroundImage: 'url(/assets/img/dtk4.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '24px', 
              overflow: 'hidden',
              position: 'relative',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3), inset 0 0 100px rgba(0,0,0,0.3)'
            }}>
              {/* Dark Overlay for Text Readability */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.4) 100%)',
                backdropFilter: 'blur(2px)',
                zIndex: 1
              }}></div>

              <div className="row align-items-center" style={{ position: 'relative', zIndex: 2 }}>
                {/* Left Side - Icon and Badge */}
                <div className="col-md-4" style={{ padding: '40px' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      width: '120px',
                      height: '120px',
                      background: 'linear-gradient(135deg, #B17ACC 0%, #7B3F9E 100%)',
                      borderRadius: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto',
                      boxShadow: '0 10px 30px rgba(123,63,158,0.4)',
                      transform: 'rotate(-5deg)',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'rotate(0deg) scale(1.05)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'rotate(-5deg) scale(1)'}>
                      <i className="bi bi-calendar-event" style={{ fontSize: '3.5rem', color: 'white' }}></i>
                    </div>
                  </div>
                </div>

                {/* Right Side - Content */}
                <div className="col-md-8" style={{ padding: '40px 40px 40px 20px' }}>
                  <div style={{
                    display: 'inline-block',
                    backgroundColor: 'rgba(123,63,158,0.2)',
                    padding: '8px 20px',
                    borderRadius: '50px',
                    marginBottom: '15px',
                    border: '1px solid rgba(123,63,158,0.3)'
                  }}>
                    <span style={{ 
                      color: '#e1e8e6ff', 
                      fontSize: '0.85rem', 
                      fontWeight: '700',
                      letterSpacing: '1.5px',
                      textTransform: 'uppercase'
                    }}>
                      📅 Upcoming Term
                    </span>
                  </div>

                  <h3 style={{ 
                    fontSize: '2.2rem', 
                    marginBottom: '15px', 
                    fontWeight: '800',
                    color: 'white',
                    letterSpacing: '-1px',
                    lineHeight: '1.2'
                  }}>
                    Autumn Term 2026
                  </h3>
                  
                  <div style={{
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    padding: '20px 2px',
                    borderRadius: '16px',
                    marginBottom: '25px',
                    backdropFilter: 'blur(10px)',
                    width: '550px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                      <i className="bi bi-calendar-check" style={{ fontSize: '1.5rem', paddingLeft: '10px', color: '#B17ACC' }}></i>
                      <div>
                        <p style={{ 
                          fontSize: '1.05rem', 
                          marginBottom: 0, 
                          color: 'white',
                          fontWeight: '600',
                          lineHeight: '1.5'
                        }}>
                          <strong>Tuesday 01 September 2026</strong> to <strong>Friday 18 December 2026</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <Link to="/contact" className="btn btn-lg" style={{ 
                    background: 'linear-gradient(135deg, #B17ACC 0%, #7B3F9E 100%)',
                    color: 'white',
                    border: 'none',
                    padding: '14px 35px', 
                    fontSize: '1rem', 
                    fontWeight: '600',
                    borderRadius: '50px',
                    boxShadow: '0 4px 15px rgba(123,63,158,0.4)',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 6px 25px rgba(123,63,158,0.5)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(123,63,158,0.4)';
                  }}>
                    Get in Touch <i className="bi bi-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* DTK Content Section */}
        <div className="row align-items-center mb-5 py-4" data-aos="fade-up" data-aos-delay="200">
          <div className="col-lg-6 p-4">
            <div className="content-box">
              {/* Badge */}
              
              <h2 className="mb-4" style={{ 
                fontSize: '2.8rem', 
                fontWeight: '700', 
                color: '#1e293b',
                lineHeight: '1.2',
                letterSpacing: '-0.5px'
              }}>
                <span style={{ color: '#7B3F9E' }}>DTK</span> College
              </h2>
              
              <p className="mb-3" style={{ 
                fontSize: '1.05rem', 
                lineHeight: '1.8', 
                color: '#475569' 
              }}>
                DTK celebrates over two decades of developing and training learners from the UK and around the world at its former Plaistow and current Stratford base.
              </p>
              
              <p className="mb-3" style={{ 
                fontSize: '1.05rem', 
                lineHeight: '1.8', 
                color: '#475569' 
              }}>
                DTK welcomes working and partnering with FE Colleges, training providers and client organisations in transforming learning, knowledge and development in East London and nationwide.
              </p>
              
              <p className="mb-4" style={{ 
                fontSize: '1.05rem', 
                lineHeight: '1.8', 
                color: '#475569' 
              }}>
                DTK continues to be a platform for many exciting developments in a changing Education sector that will lead us and our client groups into a successful future.
              </p>
              
              <Link to="/about-us" className="btn btn-lg" style={{ 
                background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                color: 'white',
                border: 'none',
                padding: '16px 40px', 
                fontSize: '1.05rem',
                fontWeight: '600',
                borderRadius: '12px',
                boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                transition: 'all 0.3s ease',
                textDecoration: 'none',
                display: 'inline-block'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(123, 63, 158, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(123, 63, 158, 0.3)';
              }}>
                Read more <i className="bi bi-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
          
          <div className="col-lg-6 p-4">
            <div className="content-image" style={{ position: 'relative' }}>
              <div style={{
                position: 'absolute',
                top: '-15px',
                right: '-15px',
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                borderRadius: '20px',
                zIndex: 0,
                opacity: 0.1
              }}></div>
              <img src="/assets/img/dtk1.jpg" alt="DTK College" className="img-fluid shadow-lg" style={{ 
                borderRadius: '20px',
                position: 'relative',
                zIndex: 1,
                border: '4px solid white'
              }} />
            </div>
          </div>
        </div>

        {/* Testimonials Section */}
        <div className="row justify-content-center mb-5 py-4" data-aos="fade-up" data-aos-delay="250">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <div style={{
                display: 'inline-block',
                backgroundColor: '#F5EBFA',
                color: '#7B3F9E',
                padding: '8px 20px',
                borderRadius: '50px',
                marginBottom: '20px',
                border: '2px solid #D4BFE3',
                fontSize: '0.9rem',
                fontWeight: '600'
              }}>
                💬 TESTIMONIALS
              </div>
              <h2 style={{ 
                fontSize: '2.2rem', 
                fontWeight: '700', 
                color: '#1e293b',
                letterSpacing: '-0.5px'
              }}>
                Students about the training team
              </h2>
            </div>
            
            <div className="shadow-lg" style={{
              background: 'white',
              borderRadius: '24px',
              padding: '50px',
              border: '1px solid #e2e8f0',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Decorative Elements */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                left: '-50px',
                width: '150px',
                height: '150px',
                background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                borderRadius: '50%',
                opacity: 0.05
              }}></div>
              <div style={{
                position: 'absolute',
                bottom: '-50px',
                right: '-50px',
                width: '150px',
                height: '150px',
                background: 'linear-gradient(135deg, #6B2F8E 0%, #5B1F7E 100%)',
                borderRadius: '50%',
                opacity: 0.05
              }}></div>
              
              <div style={{ position: 'relative', zIndex: 2 }}>
                <div className="quote-icon text-center mb-4">
                  <div style={{
                    display: 'inline-block',
                    width: '80px',
                    height: '80px',
                    backgroundColor: '#F5EBFA',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '3px solid #D4BFE3'
                  }}>
                    <i className="bi bi-quote" style={{ fontSize: '2.5rem', color: '#7B3F9E' }}></i>
                  </div>
                </div>
                
                <div className="testimonial-content text-center">
                  <p style={{ 
                    fontSize: '1.2rem', 
                    lineHeight: '1.9', 
                    color: '#475569', 
                    fontStyle: 'italic', 
                    marginBottom: '2.5rem',
                    maxWidth: '800px',
                    margin: '0 auto 2.5rem'
                  }}>
                    "The training team at DTK College has been exceptional. Their dedication and expertise have truly transformed my learning experience. 
                    I've gained invaluable skills and confidence that have prepared me for my career."
                  </p>
                  
                  <div className="student-info" style={{
                    paddingTop: '30px',
                    borderTop: '2px solid #e2e8f0'
                  }}>
                    <div style={{
                      display: 'inline-block',
                      width: '60px',
                      height: '60px',
                      backgroundColor: '#F5EBFA',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '15px',
                      border: '3px solid #7B3F9E',
                      fontSize: '1.5rem'
                    }}>
                      👩‍🎓
                    </div>
                    <h5 style={{ 
                      color: '#7B3F9E', 
                      fontWeight: '700', 
                      marginBottom: '5px',
                      fontSize: '1.2rem'
                    }}>
                      Sarah Johnson
                    </h5>
                    <p style={{ 
                      color: '#64748b', 
                      fontSize: '0.95rem',
                      marginBottom: 0
                    }}>
                      Level 3 Business Administration
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Partner Logos Section */}
        <div className="row mb-5 pb-5" data-aos="fade-up" data-aos-delay="400">
          <div className="col-12">
            <div className="text-center mb-5">
              <div style={{
                display: 'inline-block',
                backgroundColor: '#F5EBFA',
                color: '#7B3F9E',
                padding: '8px 20px',
                borderRadius: '50px',
                marginBottom: '20px',
                border: '2px solid #D4BFE3',
                fontSize: '0.9rem',
                fontWeight: '600'
              }}>
                🤝 PARTNERSHIPS
              </div>
              <h2 style={{ 
                fontSize: '2.2rem', 
                fontWeight: '700', 
                color: '#1e293b', 
                marginBottom: '15px',
                letterSpacing: '-0.5px'
              }}>
                Our <span style={{ color: '#7B3F9E' }}>Partners</span> & Accreditations
              </h2>
              <p style={{ 
                fontSize: '1.05rem', 
                color: '#64748b',
                maxWidth: '600px',
                margin: '0 auto'
              }}>
                Trusted by leading educational and professional organizations
              </p>
            </div>
            
            <style>{`
              @keyframes scroll-logos {
                0% {
                  transform: translateX(0);
                }
                100% {
                  transform: translateX(-50%);
                }
              }
              
              .logo-scroll-container {
                overflow: hidden;
                position: relative;
                padding: 3rem 0;
                background: white;
                border-radius: 20px;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
              }
              
              .logo-scroll-track {
                display: flex;
                gap: 4rem;
                animation: scroll-logos 30s linear infinite;
                width: max-content;
              }
              
              .logo-scroll-track:hover {
                animation-play-state: paused;
              }
              
              .partner-logo-item {
                flex-shrink: 0;
                width: 140px;
                height: 90px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 1rem;
                background: #f8fafc;
                border-radius: 12px;
                border: 2px solid #e2e8f0;
                transition: all 0.3s ease;
              }
              
              .partner-logo-item:hover {
                transform: scale(1.05);
                border-color: #7B3F9E;
                background: #F5EBFA;
                box-shadow: 0 4px 12px rgba(123, 63, 158, 0.15);
              }
              
              .partner-logo-item img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
                filter: grayscale(20%);
                transition: filter 0.3s ease;
              }
              
              .partner-logo-item:hover img {
                filter: grayscale(0%);
              }
            `}</style>
            
            <div className="logo-scroll-container">
              <div className="logo-scroll-track">
                <div className="partner-logo-item">
                  <img src="/assets/img/DTK-apprenticeship.png" alt="DTK Apprenticeships" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/Matrix-Logo.jpg" alt="Matrix" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/OCR.jpeg" alt="OCR" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/NCFE.jpeg" alt="NCFE" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/DCC.png" alt="DCC" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/BSC.png" alt="BSC" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/cyber-essential.png" alt="Cyber Essentials" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/Edexcel.png" alt="Edexcel" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/tr1.png" alt="TR1" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/tricollege.png" alt="TriCollege" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/vtct.png" alt="VTCT" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/ncc.jpg" alt="NCC" />
                </div>
                
                {/* Duplicate set for seamless scrolling */}
                <div className="partner-logo-item">
                  <img src="/assets/img/DTK-apprenticeship.png" alt="DTK Apprenticeships" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/Matrix-Logo.jpg" alt="Matrix" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/OCR.jpeg" alt="OCR" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/NCFE.jpeg" alt="NCFE" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/DCC.png" alt="DCC" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/BSC.png" alt="BSC" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/cyber-essential.png" alt="Cyber Essentials" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/Edexcel.png" alt="Edexcel" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/tr1.png" alt="TR1" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/tricollege.png" alt="TriCollege" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/vtct.png" alt="VTCT" />
                </div>
                <div className="partner-logo-item">
                  <img src="/assets/img/ncc.jpg" alt="NCC" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}

export default Hero;